export const styles = {
    cardActionStyleSmall: {
      zIndex: 2,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end',
    },
    headerForm: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '1em 0',
      flexWrap: 'wrap'
    },
    headerDateTimeBox: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-end'
    },
    headerTitle: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
    },
    iconHeader:{width: '2.6rem', height: '2.6em'},
    customerBoxButton: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20
    },
    contentBox: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    },
    contentField: {
      padding: 10,
      flex: 1,
    },
    contentTotal: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      padding: '1em 0',
      flexWrap: 'wrap'
    },
    contentFieldTotal: {
      padding: 10,
      flex: 1,
    },
    contentSubTotal: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'space-between',
      padding: '10px 0',
      flexWrap: 'wrap'
    },
    contentSubFieldTotal: {
      
    },
    contentTextRight: {
      alignText: 'right'
    },
    containerSmall: {
      padding: '3em 1em 6em 1em'
    },
    containerMedium: {
      padding: '0em 1em 1em 1em'
    },
  };


// WEBPACK FOOTER //
// ./src/customers/styles.js